module.exports = __webpack_public_path__ + "img/sj.9b5cddea.png";